/**
 * AdminPlataformaRedDispositivosEntidadesView — Web Component (Light DOM)
 *
 * Vista de Plataforma del panel de administración.
 * Contiene tres tabs:
 *   - Red Operativa: árbol fractal de nodos con panel de detalle.
 *   - Entidades: usuarios del sistema (admin) con CRUD.
 *   - Dispositivos: screens/VLTs/cajas con filtros y autorización de pendientes.
 * Migrado desde index.html (sección Plataforma).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminPlataformaRedDispositivosEntidadesView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
                    <!-- PLATAFORMA VIEW -->
                    <section class="view" id="view-plataforma">
                        <div class="section-header">
                            <h3 class="section-title">${t('Plataforma')}</h3>
                            <div class="view-tabs">
                                <button
                                    class="tab-btn active"
                                    data-tab="red"
                                    data-action="app:switchTab"
                                    data-view="plataforma"
                                >
                                    ${icon('git-branch')} ${t('Red Operativa')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="entidades"
                                    data-action="app:switchTab"
                                    data-view="plataforma"
                                >
                                    ${icon('user-cog')} ${t('Usuarios')}
                                </button>
                                <button
                                    class="tab-btn"
                                    data-tab="dispositivos"
                                    data-action="app:switchTab"
                                    data-view="plataforma"
                                >
                                    ${icon('monitor')} ${t('Dispositivos')}
                                </button>
                            </div>
                        </div>

                        <!-- TAB: Red Operativa (Árbol Fractal) -->
                        <div class="tab-content active" id="tab-plataforma-red">
                            <div class="nodos-layout">
                                <!-- Panel izquierdo: Árbol -->
                                <div class="nodos-tree-panel">
                                    <div class="table-header">
                                        <h3>${t('Estructura de Red')}</h3>
                                        <div class="nodos-toolbar">
                                            <div id="nodosSearchContainer" class="nodos-search-container"></div>
                                            <button
                                                id="btnToggleExpand"
                                                class="btn btn-sm"
                                                data-action="nodos:toggleExpandAll"
                                            >
                                                ${icon('chevron-down')}
                                                ${t('Expandir')}
                                            </button>
                                            <button
                                                id="btnToggleInactivos"
                                                class="btn btn-sm"
                                                data-action="nodos:toggleInactivos"
                                            >
                                                ${icon('eye-off')} ${t('Inactivos')}
                                            </button>
                                            <button class="btn btn-primary btn-sm" data-action="nodos:addChildRoot">
                                                ${t('+ Nuevo')}
                                            </button>
                                        </div>
                                    </div>
                                    <div id="nodosTreeContainer" class="nodos-tree-container">
                                        <p class="empty-state">${t('Cargando estructura...')}</p>
                                    </div>
                                </div>
                                <!-- Panel derecho: Detalle -->
                                <div class="nodos-detail-panel">
                                    <div id="nodoDetailPanel" class="nodo-detail-content">
                                        <p class="empty-state">${t('Seleccione un nodo para ver sus detalles')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- TAB: Dispositivos -->
                        <div class="tab-content" id="tab-plataforma-dispositivos">
                            <!-- Dispositivos Pendientes -->
                            <div
                                class="table-container pending-section"
                                id="dispositivosPendingSection"
                                style="display: none; margin-bottom: 20px; border-color: var(--accent-orange)"
                            >
                                <div class="table-header" style="background: rgba(245, 158, 11, 0.1)">
                                    <h3 style="color: var(--accent-orange)">${t('Pendientes de Autorizar')}</h3>
                                </div>
                                <div class="pending-cards" id="dispositivosPendingList"></div>
                            </div>
                            <!-- Dispositivos Registrados -->
                            <div class="table-container">
                                <div
                                    class="table-header"
                                    style="display: flex; justify-content: space-between; align-items: center"
                                >
                                    <h3>${t('Dispositivos Registrados')}</h3>
                                </div>
                                <div
                                    class="filter-bar"
                                    style="
                                        margin-bottom: 16px;
                                        display: flex;
                                        gap: 12px;
                                        align-items: center;
                                        flex-wrap: wrap;
                                    "
                                >
                                    <div style="position: relative; flex: 1; min-width: 200px; max-width: 300px">
                                        <img
                                            src="/assets/icons/search.svg"
                                            class="icon"
                                            style="
                                                position: absolute;
                                                left: 12px;
                                                top: 50%;
                                                transform: translateY(-50%);
                                                width: 18px;
                                                height: 18px;
                                            "
                                            alt=""
                                        />
                                        <input
                                            type="text"
                                            id="dispositivosSearchInput"
                                            class="form-input"
                                            placeholder="${t('Buscar por nombre, serial...')}"
                                            style="padding-left: 40px"
                                            data-action="dispositivos:filter"
                                        />
                                    </div>
                                    <select
                                        id="dispositivosTipoFilter"
                                        class="form-input"
                                        style="max-width: 150px"
                                        data-action="dispositivos:filter"
                                    >
                                        <option value="">${t('Todos los tipos')}</option>
                                        <option value="screen">${t('Screen')}</option>
                                        <option value="vlt">${t('VLT')}</option>
                                        <option value="caja">${t('Caja')}</option>
                                    </select>
                                    <select
                                        id="dispositivosNodoFilter"
                                        class="form-input"
                                        style="max-width: 200px"
                                        data-action="dispositivos:filter"
                                    >
                                        <option value="">${t('Todos los nodos')}</option>
                                    </select>
                                    <select
                                        id="dispositivosStatusFilter"
                                        class="form-input"
                                        style="max-width: 150px"
                                        data-action="dispositivos:filter"
                                    >
                                        <option value="">${t('Estado')}</option>
                                        <option value="online">${t('Online')}</option>
                                        <option value="offline">${t('Offline')}</option>
                                    </select>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>${t('Nombre')}</th>
                                            <th>${t('Tipo')}</th>
                                            <th>${t('Serial')}</th>
                                            <th>${t('Sorteo')}</th>
                                            <th>${t('Status')}</th>
                                            <th>${t('Acciones')}</th>
                                        </tr>
                                    </thead>
                                    <tbody id="dispositivosTable"></tbody>
                                </table>
                            </div>
                        </div>

                        <!-- TAB: Entidades (Usuarios Admin) — layout navegador + inspector,
                             mismo patrón que el árbol (centro de operaciones 2026-06). La lista
                             (ListadoConFiltrosYExport) va a la izquierda; al seleccionar un
                             usuario, su ficha aparece en el inspector derecho. -->
                        <div class="tab-content" id="tab-plataforma-entidades" style="display: none">
                            <div class="nodos-layout">
                                <div class="nodos-tree-panel">
                                    <div id="entidadesListaContainer"></div>
                                </div>
                                <div class="nodos-detail-panel">
                                    <div id="entidadDetailPanel" class="nodo-detail-content">
                                        <p class="empty-state">${t('Seleccione un usuario para ver su ficha')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
        `;
    }
}

customElements.define('admin-plataforma-red-dispositivos-entidades-view', AdminPlataformaRedDispositivosEntidadesView);
